// extracted by mini-css-extract-plugin
export default {"multipleActions":"MultipleActions_multipleActions__Fbzhs","button":"MultipleActions_button__M64ce"};